import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Text, Button } from '@components/common';
import history from '@utils/history';

const OptionContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

function PropertyNoOption(props) {
  const { isDisabled, innerProps, selectProps } = props;
  if (isDisabled) {
    return null;
  }

  const { inputValue } = selectProps;
  return (
    <OptionContainer {...innerProps} p={4}>
      <Text color="gray" mb={4}>
        {!inputValue ? 'Type Building Name' : 'No Options'}
      </Text>
      {inputValue && inputValue.length > 3 && (
        <Button
          width={1}
          onClick={() => {
            history.push('/request-property');
          }}
        >
          Request new
        </Button>
      )}
    </OptionContainer>
  );
}

PropertyNoOption.propTypes = {
  innerProps: PropTypes.any,
  isDisabled: PropTypes.bool,
  data: PropTypes.object,
  selectProps: PropTypes.object
};

export default PropertyNoOption;
